import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useClaimFileCategoryReducer = () =>
  useSelector((state: ApplicationState) => state.claimFileCategory);

